import React from "react";
import whatsappLogo from "../images/WhatsApp.svg";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  return (
    <div className="whatsapp-float">
      <a href="https://wa.me/917990094431" target="_blank" rel="noopener noreferrer">
        <img src={whatsappLogo} alt="WhatsApp" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
